const css = `.info-icon {
  cursor: help;
  font-size: var(--font-size-sm);
  color: var(--text-muted);
  transition: color 0.2s;
}
.info-icon.info-icon-small {
  font-size: var(--font-size-xs);
}
.info-icon:hover {
  color: var(--accent);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvSW5mb0ljb24iLCJzb3VyY2VzIjpbIkluZm9JY29uLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFFQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIuaW5mby1pY29uIHtcbiAgY3Vyc29yOiBoZWxwO1xuICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS1zbSk7XG4gIGNvbG9yOiB2YXIoLS10ZXh0LW11dGVkKTtcblxuICB0cmFuc2l0aW9uOiBjb2xvciAwLjJzO1xuXG4gICYuaW5mby1pY29uLXNtYWxsIHtcbiAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS14cyk7XG4gIH1cblxuICAmOmhvdmVyIHtcbiAgICBjb2xvcjogdmFyKC0tYWNjZW50KTtcbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
